import React, { useState, useEffect } from "react";
import api from '../../api/axios'; // arriba del componente, junto a los demás imports

const COLORS = {
  bg: "#200A08",
  surface: "#341210",
  surfaceAlt: "#411713",
  orange: "#FF7A33",
  gold: "#FFC93C",
  teal: "#2EC4B6",
  ink: "#FBEDE2",
  muted: "#C9A79B",
};

const FONT_DISPLAY = '"Arial Black", "Helvetica Neue", Arial, sans-serif';
const FONT_BODY = 'ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif';
const FONT_MONO = 'ui-monospace, "Cascadia Code", "SFMono-Regular", Menlo, monospace';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

useEffect(() => {
  api.get('/projects')
    .then(res => {
      console.log("Proyectos recibidos:", res.data);
      
      // Valida si la respuesta es directamente el arreglo o viene dentro de .data
      const projectsData = Array.isArray(res.data) 
        ? res.data 
        : (res.data.data || []);
        
      setProjects(projectsData);
      setLoading(false);
    })
    .catch(err => {
      console.error("Error al obtener proyectos:", err);
      setProjects([]);
      setLoading(false);
    });
}, []);

  return (
    <div
      id="Projects"
      style={{ background: COLORS.bg, color: COLORS.ink, fontFamily: FONT_BODY }}
      className="min-h-screen w-full"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <p
          style={{ fontFamily: FONT_MONO, color: COLORS.teal, letterSpacing: "0.15em" }}
          className="text-xs md:text-sm uppercase mb-6"
        >
          Trabajo
        </p>

        <div className="relative inline-block mb-14">
          <span style={{ background: COLORS.orange, transform: "skewY(-2deg)" }} className="absolute inset-0 -z-0" />
          <h1
            style={{ fontFamily: FONT_DISPLAY, color: COLORS.bg, letterSpacing: "-0.02em" }}
            className="relative z-10 text-4xl md:text-6xl uppercase px-3 py-1"
          >
            Proyectos
          </h1>
        </div>

        {loading ? (
          <div style={{ fontFamily: FONT_MONO, color: COLORS.muted }} className="text-center py-8">
            Cargando proyectos...
          </div>
        ) : projects.length === 0 ? (
          <div style={{ fontFamily: FONT_MONO, color: COLORS.muted }} className="text-center py-8">
            No hay proyectos disponibles
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, i) => {
              const rotation = [-2, 1.5, -1.5][i % 3];
              const tagColor = [COLORS.orange, COLORS.gold, COLORS.teal][i % 3];
              return (
                <a
                  key={project.id}
                  href={project.demo_url || '#'}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="post-card block"
                  style={{
                    background: COLORS.surfaceAlt,
                    borderRadius: 14,
                    padding: "1.25rem",
                    transform: `rotate(${rotation}deg)`,
                    textDecoration: "none",
                    transition: "transform 0.25s ease, box-shadow 0.25s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "rotate(0deg) translateY(-6px)";
                    e.currentTarget.style.boxShadow = "0 16px 30px rgba(0,0,0,0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = `rotate(${rotation}deg)`;
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div className="relative mb-4">
                    {project.image_url ? (
                      <img src={project.image_url} alt={project.title} className="w-full h-auto rounded-md" />
                    ) : (
                      <div 
                        style={{ 
                          background: COLORS.surface,
                          height: '200px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <span style={{ color: COLORS.muted, fontFamily: FONT_MONO }}>Sin imagen</span>
                      </div>
                    )}
                    <span
                      style={{ background: tagColor, color: COLORS.bg, fontFamily: FONT_MONO, borderRadius: 6 }}
                      className="absolute -top-3 -right-2 px-2 py-1 text-xs"
                    >
                      {project.technologies && project.technologies.length > 0 
                        ? project.technologies[0] 
                        : 'PROYECTO'}
                    </span>
                  </div>
                  <strong style={{ fontFamily: FONT_DISPLAY, color: COLORS.ink }} className="block text-lg md:text-xl uppercase leading-tight mb-1">
                    {project.title}
                  </strong>
                  <span style={{ color: COLORS.muted, fontFamily: FONT_MONO }} className="block text-xs md:text-sm">
                    {project.description || 'Sin descripción'}
                  </span>
                </a>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Projects;